import React from 'react'
import { Card, Form, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';


const getCheckDisplayValue = (props) => {
    if (props.value === true) {
        return <FontAwesomeIcon icon={faExclamation} />
    } else {
        return <FontAwesomeIcon icon={faExclamation} />
    }
};

const WorksheetDisclaimer = (props) => {
    let lg = props.colLg ? props.colLg : 12;
    let md = props.colMd ? props.colMd : 12;
    if (props.print) {
        return (
            props.value === true ?
            <Form.Group as={Col} lg={12} md={12}>
                <Form.Label>{getCheckDisplayValue(props)} {props.label}</Form.Label>
            </Form.Group> : null
        );
    } else {
        return (
            <Form.Group as={Col} lg={9} md={12} isInvalid={props.error}>
                <Form.Check type="checkbox"
                            label={props.label}
                            name={props.name}
                            id={props.name}
                            checked={props.value}
                            onBlur={props.onBlur}
                            isInvalid={props.error}
                            onChange={props.onChangeInput} />
                <Form.Text className="text-muted">{props.description}</Form.Text>
            </Form.Group>
        );
    }

}

export default WorksheetDisclaimer

//<div>{opt.optVal} + ' ' + {opt.optText}</div> 